import axios from 'axios'

const api = axios.create({
    baseURL: 'https://jsonplaceholder.typicode.com/',
})

export default api